const complianceTarget = 16;
const compliancePeriodDuration = 30;
//const complianceLimit1 = 3;
//const complianceLimit2 = 23;
const complianceRedOrangeThreshold = 20;
const complianceLimitFactor = 0.8;

export function calculateComplianceFill(
  theme: any,
  x: number | undefined,
  y: number | undefined
): string {
  if (x === undefined || y === undefined || x > y) {
    return theme.palette.complianceUndefined.main; // or transparent if possible
  } else if (compliancePeriodDuration - y + x - complianceTarget < 0) {
    return theme.palette.complianceNotAchievable.main; //16 of 30 days cannot or have not been achieved
  } else if (x >= complianceTarget) {
    return theme.palette.complianceCompleted.main; // Done (above 16)
  } else {
    if (
      Math.floor((compliancePeriodDuration - y) * complianceLimitFactor + x) >
      complianceRedOrangeThreshold
    ) {
      return theme.palette.complianceOnTrack.main; // On track to complete 16 of 30 days
    } else {
      return theme.palette.complianceAtRisk.main; //At risk of not completing 16 of 30 days
    }
  }
}

export const renderAlertFill = (theme: any, level: number) => {
  switch (level) {
    case 0:
      return theme.palette.alertUndefined.main;
    case 1:
      return theme.palette.alertLevel1.main;
    case 2:
      return theme.palette.alertLevel2.main;
    case 3:
      return theme.palette.alertLevel3.main;
    default:
      return theme.palette.alertUndefined.main;
  }
};
